module.exports = "/_next/static/images/7e5d060056e6f121c963b94cdf60774f-months-xs.png";